module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-fff text-center"
  }, [_c('backTitleBar', {
    attrs: {
      "isBackClose": true,
      "isLogOut": true
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-img",
    attrs: {
      "src": _vm.mainImg,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-36 color-333 mt-25 font-bold"
  }, [_vm._v("审核中")]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999 mt-20"
  }, [_vm._v("请等待1-3个工作日，通过后客服会与您联系")]), _vm._v(" "), _c('div', {
    staticClass: "btn click",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("\n        完成\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bd8e386","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/register/checking.vue
// module id = Uhb9
// module chunks = 51